import {
  ButtonERP,
  ChipsContainer,
  InputCurrency,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCuentaContableEmpresaAllModalAsiento } from "api/CuentaContableEmpresa.hook"
import { useCuentaContableCuentaAll } from "api/CuentaContable_Cuenta.hook"
import { TIPO_IMPORTACION_ASIENTO } from "api/Types/TipoImportacionAsiento"
import DropdownCuentasAsientos from "common/components/DropdownsCuentasContables/DropdownCuentasAsientos/DropdownCuentasAsientos"
import { FieldArray, FormikHelpers } from "formik"
import { FormikErrors } from "interfaces/Formik"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"
import {
  AsientoContableFormikProps,
  LineaAsientoFormikProps,
} from "../../constant"

const LineasAsientoContable = ({
  values,
  errors,
  setFieldValue,
}: {
  values: AsientoContableFormikProps
  errors: FormikErrors<AsientoContableFormikProps>
  setFieldValue: FormikHelpers<AsientoContableFormikProps>["setFieldValue"]
}) => {
  const { t } = useTranslation()

  const {
    cuentasContablesEmpresas: allCuentasContables,
    cuentasContablesEmpresasIsLoading: allCuentasContablesIsLoading,
    cuentasContablesEmpresasRefetch: allCuentasRefresh,
  } = useCuentaContableEmpresaAllModalAsiento()

  const { cuentasContablesEmpresas: allCuentasContablesBase } =
    useCuentaContableCuentaAll()

  return (
    <div
      className={`tw-flex tw-flex-col tw-h-[calc(100%-64px)] ${
        values.tipoImportacionAsiento ===
        TIPO_IMPORTACION_ASIENTO.LIBRO_IVA_SAGE
          ? "tw-hidden"
          : ""
      }`}
    >
      <div className='tw-gap-2 tw-bg-white tw-w-full tw-grid tw-grid-cols-14 tw-items-center tw-h-fit tw-px-8 tw-mb-1 tw-font-medium tw-text-sm'>
        <span className='tw-col-span-3'>{t("diario.modal.headerAccount")}</span>
        <span className='tw-col-span-2'>{t("diario.modal.headerDoc")}</span>
        <span className='tw-col-span-3'>{t("diario.modal.headerDesc")}</span>
        <span className='tw-col-span-2'>
          {t("contactos.editar.dataAdvance.labelLabel")}
        </span>
        <div className='tw-col-span-4 tw-flex tw-flex-row tw-gap-2 tw-items-center '>
          <span className='!tw-flex-1 tw-text-end'>
            {t("diario.modal.headerDebit")}
          </span>
          <span className='!tw-flex-1 tw-text-end'>
            {t("diario.modal.headerCredit")}
          </span>
          <span className='tw-w-10 tw-mr-1 tw-ml-5' />
        </div>
      </div>
      <FieldArray name='lineas'>
        {({ push, remove }) => {
          return (
            <div className='tw-w-full tw-px-5 tw-py-3 tw-bg-background tw-h-[calc(100%-24px)] tw-flex tw-flex-col tw-justify-between tw-rounded-md'>
              <div className='tw-flex tw-flex-col tw-flex-1 tw-h-[calc(100%-72px)] tw-overflow-y-auto'>
                {values.lineas.map(
                  (linea: LineaAsientoFormikProps, index: number) => (
                    <div
                      key={linea.id || index}
                      className='tw-gap-2 tw-bg-white tw-w-full tw-grid tw-grid-cols-14 tw-items-center tw-h-14 tw-p-2 tw-mb-2'
                    >
                      <div className='tw-h-full tw-col-span-3'>
                        <DropdownCuentasAsientos
                          options={allCuentasContables}
                          onChange={({ value }: { value: string }) =>
                            setFieldValue(
                              `lineas[${index}].cuentaContableId`,
                              value,
                              Boolean(errors?.lineas?.[index]?.cuentaContableId)
                            )
                          }
                          className={`!tw-border-neutral-25 ${
                            errors?.lineas?.[index]?.cuentaContableId
                              ? "!tw-border-danger !tw-text-danger"
                              : ""
                          } !tw-text-sm hover:!tw-border-neutral-75`}
                          id={`${linea.id}-cuentaContableId`}
                          loading={allCuentasContablesIsLoading}
                          value={linea.cuentaContableId}
                          listaDeCuentasBase={allCuentasContablesBase}
                          refreshFetchData={allCuentasRefresh}
                          withCreateCuenta
                        />
                      </div>
                      <InputText
                        className='tw-h-full tw-col-span-2 !tw-text-sm !tw-border-neutral-25 hover:!tw-border-neutral-75'
                        value={linea.numeroDocumento}
                        onChange={(e) =>
                          setFieldValue(
                            `lineas[${index}].numeroDocumento`,
                            e.target.value
                          )
                        }
                      />
                      <InputText
                        className='tw-h-full tw-col-span-3 !tw-text-sm !tw-border-neutral-25 hover:!tw-border-neutral-75'
                        value={linea.descripcion}
                        onChange={(e) =>
                          setFieldValue(
                            `lineas[${index}].descripcion`,
                            e.target.value
                          )
                        }
                      />
                      <div className='tw-col-span-2 tw-flex tw-flex-col tw-gap-1 w-4'>
                        <ChipsContainer
                          addOnBlur
                          max={5}
                          maxLength={20}
                          separator=','
                          allowDuplicate={false}
                          value={linea?.listadoTags}
                          onChange={(e) =>
                            setFieldValue(
                              `lineas[${index}].listadoTags`,
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className='tw-col-span-4 tw-flex tw-flex-row tw-gap-2 tw-items-center'>
                        <div className=' tw-h-full tw-flex-1'>
                          <InputCurrency
                            value={linea.debe ?? undefined}
                            onChange={(e) =>
                              setFieldValue(
                                `lineas[${index}].debe`,
                                Number.isNaN(e) ? null : e
                              )
                            }
                            placeholder='0,00'
                            className='tw-h-full !tw-text-sm'
                            disabled={Boolean(linea.haber)}
                          />
                        </div>
                        <div className='tw-h-full tw-flex-1'>
                          <InputCurrency
                            value={linea.haber ?? undefined}
                            onChange={(e) =>
                              setFieldValue(
                                `lineas[${index}].haber`,
                                Number.isNaN(e) ? null : e
                              )
                            }
                            placeholder='0,00'
                            className='tw-h-full !tw-text-sm'
                            disabled={Boolean(linea.debe)}
                          />
                        </div>
                        <ButtonERP
                          onClick={() => {
                            remove(index)
                            values.lineas.length === 1 &&
                              push({
                                id: uuidv4(),
                                cuentaContableId: undefined,
                                numeroDocumento: "",
                                descripcion: "",
                                debe: null,
                                haber: null,
                              })
                          }}
                          icon={<FontAwesomeIcon icon={["fal", "xmark"]} />}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className='tw-w-full tw-flex tw-justify-center tw-my-4'>
                <ButtonERP
                  customize={{
                    type: "white",
                    size: "md",
                  }}
                  onClick={() =>
                    push({
                      id: uuidv4(),
                      cuentaContableId: undefined,
                      numeroDocumento: "",
                      descripcion: "",
                      debe: null,
                      haber: null,
                    })
                  }
                  icon={<FontAwesomeIcon icon={["fal", "plus"]} />}
                  label={`${t("diario.modal.addAccountLabel")}`}
                />
              </div>
            </div>
          )
        }}
      </FieldArray>
    </div>
  )
}

export default LineasAsientoContable
